import React, { createContext, useContext } from 'react';

// Simplified Romanian-only context - no language switching
const translations = {
  // Common translations for components that use t() function
  'users.search': 'Caută utilizatori...',
  'users.loadError': 'Eroare la încărcarea utilizatorilor',
  'rank.promotion': 'Cerere de promovare în rank',
  'rank.error': 'Eroare la trimiterea cererii de promovare. Vă rugăm să încercați din nou.',
  'video.error': 'Eroare la încărcarea videoclipului',
  'profile.firstName': 'Prenume',
  'profile.lastName': 'Nume',
  'profile.email': 'Email',
  'profile.phone': 'Număr de telefon',
  'profile.edit': 'Editează',
  'profile.save': 'Salvează',
  'profile.cancel': 'Anulează',
  'profile.addDoterraAccount': 'Adaugă Cont doTERRA',
  'profile.noDoterraAccount': 'Nu aveți încă un cont doTERRA asociat profilului dumneavoastră.',
  'profile.doterraAccount': 'Cont doTERRA',
  'profile.doterraInfo': 'Informații doTERRA',
  'profile.personalInfo': 'Informații Personale'
};

// Create Language Context
const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Always Romanian - no language switching
  const language = 'ro';

  // Simple translation function
  const t = (key, params = {}) => {
    let translation = translations[key] || key;
    
    // Replace parameters in translation if any
    if (params && typeof params === 'object') {
      Object.keys(params).forEach(param => {
        const regex = new RegExp(`{${param}}`, 'g');
        translation = translation.replace(regex, params[param]);
      });
    }
    
    return translation;
  };

  const value = {
    language,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
